import { Disease } from '../../../ana-toolbox'
import { DiseaseType } from '../../../ana-toolbox'

export const isSameName =
  (name: string) =>
  (disease: Disease): boolean =>
    disease.name === name

export const isDifferentName =
  (name: string) =>
  (disease: Disease): boolean =>
    disease.name !== name

export const isSameType =
  (type: DiseaseType) =>
  (disease: Disease): boolean =>
    disease.type === type

export const getOtherDiseaseForType = (
  type: DiseaseType,
  selectedDisease: Disease[],
  allDiseases: Disease[]
): Disease[] => {
  const selectedDiseasesForType = selectedDisease.filter(isSameType(type))

  const otherDiseases = selectedDiseasesForType.filter((selected) => !allDiseases.some(isSameName(selected.name)))

  return otherDiseases
}
